export default __webpack_public_path__ + "static/media/vacunacion.18e682df.png";